/**
 * Espejo de multicotizadorBackend/src/utils/formatClienteNombre.ts
 * Arma el nombre a mostrar. Fallback a razonSocial/razon_social si no hay nombre ni apellido.
 */
export const formatClienteNombreCompleto = (cliente, fallback = '-') => {
   const nombre = (cliente?.nombre ?? '').trim();
   const apellido = (cliente?.apellido ?? '').trim();
   const partes = [nombre, apellido].filter(Boolean);

   if (partes.length > 0) {
      return partes.join(' ');
   }

   const razonSocial = (cliente?.razonSocial ?? cliente?.razon_social ?? '').trim();
   if (razonSocial) {
      return razonSocial;
   }

   return fallback;
};
